module.exports = __webpack_public_path__ + "static/media/psophus_stridulus_001_APA.c5b86778.png";